import firebase from '@modules/firebase';
import 'firebase/remote-config';
import { logger } from '@modules/logger';
import { useEffect, useState } from 'react';

let remoteConfigSingleton: RemoteConfig;

type RemoteConfig = firebase.remoteConfig.RemoteConfig;

/** Loads and initialises firebase remote config */
export function useRemoteConfig(): RemoteConfig | undefined {
  const [state, setState] = useState<RemoteConfig>(remoteConfigSingleton);

  useEffect(() => {
    if (state) {
      return;
    }
    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 10000;
    remoteConfig
      .fetchAndActivate()
      .then(() => {
        setState(remoteConfig);
        remoteConfigSingleton = remoteConfig;
      })
      .catch((e) => logger.error('remoteConfig failed to activate', { error: e }));
  }, [state]);

  return state;
}
